import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/client/src/app/inventory-management/components/InventoryDashboard.tsx");
